import React, { useState, useEffect } from "react";
import { Col, Row, Button, Form, Image, Modal } from "react-bootstrap";
import SVG from "react-inlinesvg";
import {
  NewInputText,
  NewSelectBoxInput,
} from "../../../../../../reusableComponents/inputReusableComponent/InputBoxComponent";
import {
  ReusableOnboardingButton,
  ReusableOnboardingMapButton,
} from "../../../../../../vendorOnboradingComponents/reusableOnboardingComponent/ButtonReusable/ReusableOnboardingButton";
import { TopTextReusableComponent } from "../../../../../../vendorOnboradingComponents/reusableOnboardingComponent/TopTextReusable/TopTextReusableComponent";
import {
  FormControl,
  IconButton,
  InputAdornment,
  OutlinedInput,
  makeStyles,
  InputLabel,
  Select,
  TextField,
} from "@material-ui/core";
import KeyboardArrowDownIcon from "@material-ui/icons/KeyboardArrowDown";
import SearchIcon from "@material-ui/icons/Search";
import { AddButtonIconComponent } from "../../../../../../reusableComponents/buttonReusableComponent/ButtonReusableComponent";
import Scrollbars from "react-custom-scrollbars";
import SpeechRecognition, {
  useSpeechRecognition,
} from "react-speech-recognition";
//import KeyboardArrowDownIcon from "@material-ui/icons/KeyboardArrowDown";
import { useFormik } from "formik";
import * as yup from "yup";
import SimpleReactLightbox from "simple-react-lightbox";
import { MultipleImageUploadComponent } from "../../../../../../reusableComponents/imageUploadReusableComponent/MultipleImageUploadComponent";
import axios from "axios";
import Alert from "react-s-alert";
import { serverApi, videoUploadSize } from "../../../../../.././../config/Keys";
import PropTypes from "prop-types";
import { connect } from "react-redux";
//import {  } from "../../../../../../../../store/actions/VendorSubscriptionAction/vendorSubscriptionGetAction";
import {
  create_new_item_menu_setup,
  get_category_menu_setup_without_loader,
  update_item_menu_setup,
  get_menu_items,
} from "../../../../../../../store/actions/VendorSubscriptionAction/vendorSubscriptionGetAction";
import AlertDialogProgress from "../../../../../../reusableComponents/allPopupReusable/DialogProgression";
import Slider from "react-slick";
import { useHistory } from "react-router-dom";
import { Fragment } from "react";

import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";

import ReactChipInput from "react-chip-input";
import { LearnMore } from "../../../../../superAdminAllComponent/SuperAdminAddVendorComponent/restaurantDetailsLogoVideo/SuperAdminAddRestaurantDetails";
import { MenuItem } from "@material-ui/core";

import {
  getCountries,
  getCountryCallingCode,
} from "react-phone-number-input/input";
import en from "react-phone-number-input/locale/en.json";
import { SuggestNewButton } from "../../../../../../vendorOnboradingComponents/reusableOnboardingPopupComponent/suggestNew/SuggestNewButton";
import { DEFAULT_ITEM_IMAGE } from "../../../../../../../enums/GlobalEnums";
import { ITEMTYPEVEG } from "../../../../../../../enums/OrderEnums";

const useStyles = makeStyles((theme) => ({
  formControl: {
    minWidth: "100%",
    marginBottom: "1rem",
  },
  selectEmpty: {
    marginTop: theme.spacing(2),
  },
}));

// const validate = (values) => {
//   const errors = {};

//   if (values.food_type.length === 0) {
//     errors.food_type = "Please select food type";
//   }

//   return errors;
// };

const BasicDetails = (props) => {
  let history = useHistory();
  const classes = useStyles();
  const { transcript } = useSpeechRecognition();
  //state
  const [errors, setErrors] = useState({});
  const [keywords, setKeywords] = useState([]);
  const [keywordsText, setKeywordsText] = useState("");
  const [utterancesVoice, setUtterancesVoice] = useState([]);
  const [utterancesVoiceText, setUtterancesVoiceText] = useState("");
  const [state, setState] = useState({
    all_food_type: [
      { _id: 1, title: "Crustacean" },
      { _id: 2, title: "Gluten Free" },
      { _id: 3, title: "Halal" },
      { _id: 4, title: "Kosher" },
      { _id: 5, title: "Lactose Free" },
      { _id: 6, title: "Nuts Free" },
      { _id: 7, title: "Organic" },
      { _id: 8, title: "Pescatarian" },
      { _id: 9, title: "Seafood" },
    ],
    selected_food_type: [
      { _id: 3, title: "Halal" },
      { _id: 4, title: "Kosher" },
      { _id: 5, title: "Lactose Free" },
    ],
    primary_food_type: { _id: 5, title: "Lactose Free" },
    countryOrigin: "",
  });
  const [productData, setProductData] = useState(false);

  //const [Video, setVideo] = useState(null);
  const selecthandleChange = (e) => {
    setState({
      ...state,
      [e.target.name]: e.target.value,
    });
  };
  const thumbnail = true;

  const takeToDashboard = (e, to) => {
    e.preventDefault();
    if (history.location.pathname.includes("fastfood/menusetup/additem")) {
      history.push("/fastfood/menusetup");
    } else if (
      history.location.pathname.includes("additemavailablity") ||
      props.itemAvailabilityPathName === "/itemavailablitydashboard"
    ) {
      history.push({
        pathname: "/menusetup-dashboard",
        state: {
          globalmenu: to === 1 ? true : false,
          chainMenu: to === 2 ? true : false,
        },
      });
    } else if (
      history.location.pathname.includes("multi-service/menusetup/additem")
    ) {
      history.push("/multi-service/menusetup");
    } else if (
      props.auth.user.VendorUser.has_admin_approved &&
      props.auth.user.VendorUser.have_vendor_submitted_details
    ) {
      history.push({
        pathname: "/menusetup-dashboard",
        state: {
          globalmenu: to === 1 ? true : false,
          chainMenu: to === 2 ? true : false,
        },
      });
    } else {
      history.push("/casual-fine-dining/menusetup");
    }
  };

  const onSubmit = (e) => {
    e.preventDefault();
    formikStep3.handleSubmit();
  };

  const [step, setStep] = useState(1);
  const handleStepChange = (v) => setStep(v);

  /*******************************
   * Add Utterances Voice Action
   ******************************/
  const addUtterancesVoiceAction = (e) => {
    e.preventDefault();
    let utterancesVoiceTextVr = utterancesVoiceText;
    let utterancesVoiceArr = utterancesVoice;
    if (utterancesVoiceTextVr === "") {
      errors.utterancesVoiceTextVr = "Utterances voice is Required";
      setErrors({
        errors: errors,
      });
    } else if (
      utterancesVoiceArr.some((diner) => diner === utterancesVoiceTextVr)
    ) {
      alert("Utterances voice already exits");
    } else {
      utterancesVoiceArr.push(utterancesVoiceTextVr);
      setUtterancesVoice(utterancesVoiceArr);
      formik.setFieldValue("utterancesVoice", utterancesVoiceArr);
      setUtterancesVoiceText("");
    }
  };

  const addUtterancesVoiceActionMic = (valueText) => {
    //e.preventDefault();
    let utterancesVoiceTextVr = valueText;
    let utterancesVoiceArr = utterancesVoice;
    if (utterancesVoiceTextVr === "") {
      errors.utterancesVoiceTextVr = "Uterances voice is Required";
      setErrors({
        errors: errors,
      });
    } else if (
      utterancesVoiceArr?.some((diner) => diner === utterancesVoiceTextVr)
    ) {
      alert("Utterances voice already exits");
    } else {
      utterancesVoiceArr.push(utterancesVoiceTextVr);
      setUtterancesVoice(utterancesVoiceArr);
      formik.setFieldValue("utterancesVoice", utterancesVoiceArr);
      setUtterancesVoiceText("");
    }
  };

  /*************************************
   * @DESC Utterances Voice Change Handlers
   ************************************/
  const onUtterancesVoiceChangeHandler = (e) => {
    setUtterancesVoiceText(e.target.value);
  };
  /*************************************
   * @DESC Remove utterancesVoice Change Handlers
   ************************************/
  const removeUtterancesVoiceAction = (indexId) => (e) => {
    var data = [...utterancesVoice];
    data.splice(indexId, 1);
    setUtterancesVoice(data);
    formik.setFieldValue("utterancesVoice", data);
  };

  /*******************************
   * Add Keywords Action
   ******************************/
  const addKeywordsAction = (e) => {
    e.preventDefault();
    let keywordsTextVr = keywordsText;
    let keywordsArr = keywords;
    if (keywordsTextVr === "") {
      errors.keywordsTextVr = "Keywords is Required";
      setErrors({
        errors: errors,
      });
    } else if (keywordsArr.some((diner) => diner === keywordsTextVr)) {
      alert("Keywords Already Exits");
    } else {
      keywordsArr.push(keywordsTextVr);
      setKeywords(keywordsArr);
      setKeywordsText("");
    }
  };
  const addKeywordsActionMic = (valueText) => {
    // e.preventDefault();
    let keywordsTextVr = valueText;
    let keywordsArr = keywords;
    if (keywordsTextVr === "") {
      errors.keywordsTextVr = "Keywords is Required";
      setErrors({
        errors: errors,
      });
    } else if (keywordsArr.some((diner) => diner === keywordsTextVr)) {
      alert("Keywords Already Exits");
    } else {
      keywordsArr.push(keywordsTextVr);
      setKeywords(keywordsArr);
      setKeywordsText("");
    }
  };

  /*************************************
   * @DESC Keywords Change Handlers
   ************************************/
  const onKeywordsChangeHandler = (e) => {
    setKeywordsText(e.target.value);
  };
  /*************************************
   * @DESC Remove Keywords Change Handlers
   ************************************/
  const removeKeywordsAction = (indexId) => (e) => {
    var data = [...keywords];
    data.splice(indexId, 1);
    setKeywords(data);
  };

  // step 1

  const [count, setCount] = useState(1);
  const [menuCategory, setMenuCategory] = useState([]);

  const onChangeMenuCategory = (category_id) => {
    formik.setFieldValue("category", category_id);
  };

  const onClickStep2 = (e) => {
    e.preventDefault();
    setCount(count + 1);
    formik.handleSubmit();
  };

  useEffect(() => {
    if (formik.errors && formik.errors.ext_id) {
      let ext_id = document.getElementById("ext_id");
      ext_id.focus();
    } else if (formik.errors && formik.errors.name) {
      let itemNameElement = document.getElementById("name");
      itemNameElement.focus();
    } else if (formik.errors && formik.errors.description) {
      let itemDescElement = document.getElementById("description");
      itemDescElement.focus();
    } else if (formik.errors && formik.errors.ingredient_description) {
      let ingredient_descriptionElement = document.getElementById(
        "ingredient_description"
      );
      ingredient_descriptionElement && ingredient_descriptionElement.focus();
    }
  }, [count]);

  const product_classification =
    history?.location?.state?.category.product_classification || "";

  const formik = useFormik({
    initialValues: {
      ext_id: "",
      name: "",
      category: "",
      description: "",
      ingredient_description: "",
      keywords: [],
      utterancesVoice: [],
    },
    validationSchema: yup.object({
      // ext_id: yup
      //   .string()
      //   .max(20, "Must be 20 characters or less")
      //   .required("Ext item id is required"),
      name: yup
        .string()
        .max(128, "Must be 128 characters or less")
        .required("Item name is required"),
      category: yup.string().required("Please select atleast one category"),
      description: yup.string().required("Item description is required"),
      ingredient_description: yup
        .string()
        .required("Ingredient description is required"),
    }),

    onSubmit: (values) => {
      if (extIdData.includes(formik.values.ext_id)) {
        Alert.error(
          `<h4> You have already assigned this ext id to another item</h4>`,
          {
            position: "top-rigfht",
            effect: "bouncyflip",
            beep: true,
            html: true,
            timeout: 3000,
            offset: 35,
          }
        );
      } else {
        formik.setFieldValue("keywords", keywords);
        formik.setFieldValue("utterancesVoice", utterancesVoice);
        if (Object.entries(props.menuCategoryItems).length !== 0) {
          let selectedFoodType = props.menuCategoryItems.food_type;
          let updateFoodType = [];
          let updateSelectedFoodType = [];
          for (let i = 0; i < foodType.length; i++) {
            if (selectedFoodType.includes(foodType[i]._id)) {
              updateSelectedFoodType.push({
                title: foodType[i].title,
                _id: foodType[i]._id,
              });
            } else {
              updateFoodType.push({
                title: foodType[i].title,
                _id: foodType[i]._id,
              });
            }
          }
          setFoodType(updateFoodType);
          setSelectedFoodType(updateSelectedFoodType);
          formikStep2.setFieldValue("food_type", updateSelectedFoodType);
        }
        if (
          props.productClassification === "Beverage" ||
          props.productClassification === "Alcoholic Beverage" ||
          props.productClassification === "Packed Beverage" ||
          props.productClassification === "Packed Alcoholic Beverage"
        ) {
          if (Object.entries(props?.menuCategoryItems).length !== 0) {
            let selectedBeveragesType =
              props?.menuCategoryItems?.beverages_type;
            let updateBeveragesType = [];
            let updateSelectedBeveragesType = [];
            for (let i = 0; i < beveragesType.length; i++) {
              if (
                selectedBeveragesType &&
                selectedBeveragesType.includes(beveragesType[i]._id)
              ) {
                updateSelectedBeveragesType.push({
                  title: beveragesType[i].title,
                  _id: beveragesType[i]._id,
                });
              } else {
                updateBeveragesType.push({
                  title: beveragesType[i].title,
                  _id: beveragesType[i]._id,
                });
              }
            }
            setBeveragesType(updateBeveragesType);
            setSelectedBeveragesType(updateSelectedBeveragesType);
            formikStep2.setFieldValue(
              "beverages_type",
              updateSelectedBeveragesType
            );
          }
        }
        handleStepChange(2);
      }
    },
  });

  const [countStep2, setCountStep2] = useState(1);

  const [cruisneType, setCrusineType] = useState([]);

  const [preperationTime, setPreperationTime] = useState([
    { id: 0, name: 0 },
    { id: 1, name: 5 },
    { id: 2, name: 10 },
    { id: 3, name: 15 },
    { id: 4, name: 20 },
    { id: 5, name: 25 },
    { id: 6, name: 30 },
    { id: 7, name: 35 },
    { id: 8, name: 40 },
    { id: 9, name: 45 },
    //{ id: 10, name: "Other" },
  ]);

  const onClickStep3 = (e) => {
    e.preventDefault();

    setCountStep2(countStep2 + 1);
    formikStep2.handleSubmit();
  };

  useEffect(() => {
    if (formikStep2.errors && formikStep2.errors.itemType) {
      let itemTypeNameElement = document.getElementById("itemType");
      itemTypeNameElement.focus();
    } else if (formikStep2.errors && formikStep2.errors.cuisin_type) {
      let cTypeNameElement = document.getElementById("cuisin_type");
      cTypeNameElement.focus();
    } else if (formikStep2.errors && formikStep2.errors.prepTime) {
      let prepNameElement = document.getElementById("prepTime");
      prepNameElement.focus();
    }
    //  else if (productData) {
    //   if (formikStep2.errors && formikStep2.errors.primary_beverages_type) {
    //     let focusPrimaryBeveragesElement = document.getElementById(
    //       "focusPrimaryBeverages"
    //     );
    //     focusPrimaryBeveragesElement.focus();
    //   } else {
    //     if (formikStep2.errors && formikStep2.errors.primary_food_type) {
    //       let vegNonNameElement = document.getElementById("focusPrimary");
    //       vegNonNameElement.focus();
    //     }
    //   }
    // }
  }, [countStep2]);

  const vegNon = () => {
    formikStep2.setFieldValue("veg", false);
  };

  const itemTypeAction = (value) => {
    formikStep2.setFieldValue("itemType", value);
  };

  // step2

  const [foodType, setFoodType] = useState([]);
  const [beveragesType, setBeveragesType] = useState([]);

  const [selectedFoodType, setSelectedFoodType] = useState([]);
  const [selectedBeveragesType, setSelectedBeveragesType] = useState([]);

  const onClickAddFoodType = (itemName, id) => {
    let data = selectedFoodType;
    let updateState = [];
    for (let i = 0; i < foodType.length; i++) {
      if (foodType[i]._id !== id) {
        updateState.push({ title: foodType[i].title, _id: foodType[i]._id });
      } else {
        data.push({ title: foodType[i].title, _id: foodType[i]._id });
      }
    }
    if (
      typeof data != "undefined" &&
      data != null &&
      data.length != null &&
      data.length === 1
    ) {
      setFoodType(updateState);
      setSelectedFoodType(data);
      formikStep2.setFieldValue("food_type", data);
      formikStep2.setFieldValue("primary_food_type", id);
    } else {
      setFoodType(updateState);
      setSelectedFoodType(data);
      formikStep2.setFieldValue("food_type", data);
    }
  };

  const removeFoodType = (itemName, itemId) => {
    if (formikStep2.values.primary_food_type === itemId) {
      formikStep2.setFieldValue("primary_food_type", "");
    }
    let updateState = foodType;
    updateState.push({ title: itemName, _id: itemId });
    setFoodType(updateState);
    let data = selectedFoodType;
    data = data.filter((item) => {
      return item._id !== itemId;
    });
    setSelectedFoodType(data);
    formikStep2.setFieldValue("food_type", data);
  };

  const setPrimaryFoodType = (itemId) => {
    formikStep2.setFieldValue("primary_food_type", itemId);
  };

  const onClickAddBeveragesType = (itemName, id) => {
    let data = selectedBeveragesType;
    let updateState = [];
    for (let i = 0; i < beveragesType.length; i++) {
      if (beveragesType[i]._id !== id) {
        updateState.push({
          title: beveragesType[i].title,
          _id: beveragesType[i]._id,
        });
      } else {
        data.push({ title: beveragesType[i].title, _id: beveragesType[i]._id });
      }
    }
    if (
      typeof data != "undefined" &&
      data != null &&
      data.length != null &&
      data.length === 1
    ) {
      setBeveragesType(updateState);
      setSelectedBeveragesType(data);
      formikStep2.setFieldValue("beverages_type", data);
      formikStep2.setFieldValue("primary_beverages_type", id);
    } else {
      setBeveragesType(updateState);
      setSelectedBeveragesType(data);
      formikStep2.setFieldValue("beverages_type", data);
    }
  };

  const removeBeveragesType = (itemName, itemId) => {
    if (formikStep2.values.primary_beverages_type === itemId) {
      formikStep2.setFieldValue("primary_beverages_type", "");
    }
    let updateState = beveragesType;
    updateState.push({ title: itemName, _id: itemId });
    setBeveragesType(updateState);
    let data = selectedBeveragesType;
    data = data.filter((item) => {
      return item._id !== itemId;
    });
    setSelectedBeveragesType(data);
    formikStep2.setFieldValue("beverages_type", data);
  };

  const setPrimaryBeveragesType = (itemId) => {
    formikStep2.setFieldValue("primary_beverages_type", itemId);
  };

  const formikStep2 = useFormik({
    initialValues: {
      veg: true,
      itemType: 1,
      food_type: [],
      primary_food_type: {},
      beverages_type: [],
      primary_beverages_type: {},
      cuisin_type: {},
      prepTime: "",
    },
    // validate,
    validationSchema: yup.object({
      // veg: yup.string().required("Please select any one option"),
      // food_type: yup.string().required("Please select any one option"),
      // primary_food_type: yup
      //   .string()
      //   .required("Please select primary food type"),
      cuisin_type: yup.string().required("Please select crusine type"),
      prepTime: yup.string().required("Please select preparation time"),
    }),

    onSubmit: (values) => {
      if (productData) {
        if (formikStep2.values.beverages_type.length <= 0) {
          Alert.error(`<h4>Please select Beverage type option</h4>`, {
            position: "top-right",
            effect: "bouncyflip",
            beep: true,
            html: true,
            timeout: 3000,
            offset: 35,
          });
        } else if (formikStep2.values.primary_beverages_type === "") {
          Alert.error(`<h4>Please select beverage primary option</h4>`, {
            position: "top-right",
            effect: "bouncyflip",
            beep: true,
            html: true,
            timeout: 3000,
            offset: 35,
          });
        } else {
          handleStepChange(3);
        }
      } else {
        if (formikStep2.values.primary_food_type === "") {
          Alert.error(`<h4>Please select Food type option</h4>`, {
            position: "top-right",
            effect: "bouncyflip",
            beep: true,
            html: true,
            timeout: 3000,
            offset: 35,
          });
        } else {
          handleStepChange(3);
        }
      }
    },
  });

  // step 3

  /*************************************
   * @DESC Multiple Bank Details Image Upload
   ************************************/
  const [combined, setCombined] = React.useState("");
  const [restaurant_pictures_new, setResPicNew] = React.useState([]);
  const onCompleteUploadMultipleCrop = (e, file) => {
    let oldData = formikStep3.values.images;
    let newData = e;
    let mergedData = oldData.concat(newData);
    // setBank_Information(mergedData);
    formikStep3.setFieldValue("images", mergedData);
    if (thumbnail) {
      let thumbData = formikStep3.values.image_thumbnails;
      let url = e.split("/");
      url.splice(url.length - 1, 0, "thumbnail");
      url = url.join("/");
      thumbData = thumbData.concat(url);
      formikStep3.setFieldValue("image_thumbnails", thumbData);
    }

    cancelFiles(file);
  };

  const cancelFiles = (file) => {
    let restaurant_pictures_temp = restaurant_pictures_new;

    let newToUpload = restaurant_pictures_temp.filter((item, index) => {
      return item.name !== file.name;
    });
    setResPicNew(newToUpload);
  };

  const bankUploadMultipleFiles = (e) => {
    // this.setState({ bankImageLoader: true });
    if (formikStep3.values.images.length + e.target.files.length > 6) {
      Alert.error(`<h4>Cannot upload  more than 6 images</h4>`, {
        position: "top-right",
        effect: "bouncyflip",
        beep: true,
        html: true,
        timeout: 3000,
        offset: 35,
      });
    } else {
      const vendor_id = props.auth.user.VendorUser._id;
      let restaurant_name;
      if (props.onboarding.restaurant_name) {
        restaurant_name = props.onboarding.restaurant_name.split(" ").join("");
      } else {
        restaurant_name = "";
      }

      const combined = vendor_id + "_" + restaurant_name;
      const data = new FormData();
      let flag = false;
      var newUploaded = [];
      var docs = false;
      for (let i = 0; i < e.target.files.length; i++) {
        //let allPicures = bank_informaion;
        let allPicures = formikStep3.values.images;
        allPicures.some((phone) => {
          if (
            phone.split(`${restaurant_name}-`)[1] === e.target.files[i].name
          ) {
            flag = true;
          }
        });
        if (!flag) {
          if (e.target.files[i].type === "application/pdf") {
            // docs.push(e.target.files[i]);
            docs = true;
            data.append("files", e.target.files[i]);
          } else {
            newUploaded.push(e.target.files[i]);
          }
        }
      }
      if (!flag) {
        setResPicNew(newUploaded);
        setCombined(combined);

        if (docs) {
          axios
            .post(`${serverApi}/upload-assets?uploadSide=${combined}`, data)
            .then((res) => {
              // let oldData = bank_informaion;
              let oldData = formikStep3.values.images;
              let newData = res.data;
              let mergedData = oldData.concat(newData);
              // setBank_Information(mergedData);
              formikStep3.setFieldValue("images", mergedData);
              Alert.success(`<h4> Image Upload Successfully</h4>`, {
                position: "top-right",
                effect: "bouncyflip",
                beep: true,
                html: true,
                timeout: 3000,
                offset: 35,
              });
            })
            .catch((err) => {
              // this.setState({ bankImageLoader: false });
              Alert.error(`<h4>${err}</h4>`, {
                position: "top-right",
                effect: "bouncyflip",
                beep: true,
                html: true,
                timeout: 3000,
                offset: 35,
              });
            });
        }
      } else {
        // this.setState({ bankImageLoader: false });
        Alert.error(`<h4>Can not upload the same image</h4>`, {
          position: "top-right",
          effect: "bouncyflip",
          beep: true,
          html: true,
          timeout: 3000,
          offset: 35,
        });
      }
    }
  };

  const bankDocMultipleRemove = (indexId) => {
    let allImages = formikStep3.values.images.filter((item, index) => {
      return index !== indexId;
    });
    let thumbImage = formikStep3.values.image_thumbnails.filter(
      (item, index) => {
        return index !== indexId;
      }
    );
    formikStep3.setFieldValue("images", allImages);
    formikStep3.setFieldValue("image_thumbnails", thumbImage);
    //setBank_Information(allBankDetails);
  };
  const [progress, setProgress] = React.useState(0);
  const uploadVideo = (e) => {
    if (e.target.files && e.target.files[0].size) {
      if (e.target.files[0].size > videoUploadSize) {
        alert("File is too Big");
      } else {
        //setLoading(true);
        const data = new FormData();
        data.append("file", e.target.files[0]);
        axios
          .post(`${serverApi}/upload-assets-video`, data, {
            headers: {
              "Content-Type": "multipart/form-data",
            },
            onUploadProgress: (progressEvent) => {
              setProgress((progressEvent.loaded / progressEvent.total) * 100);
            },
          })
          .then((res) => {
            //setLoading(false);
            Alert.success(`<h4>Video uploaded sucessfully</h4>`, {
              position: "top-right",
              effect: "bouncyflip",
              beep: true,
              html: true,
              timeout: 3000,
              offset: 35,
            });

            //setVideo(res.data[0]);
            //formik.setFieldValue("photos", res.data[0]);
            formikStep3.setFieldValue(`videos[0]`, res.data);
          })
          .catch((err) => {
            Alert.error(`<h4>Error while uploading the video</h4>`, {
              position: "top-right",
              effect: "bouncyflip",
              beep: true,
              html: true,
              timeout: 3000,
              offset: 35,
            });
          });
      }
    }
  };

  const removeVideo = () => {
    formikStep3.setFieldValue(`videos[0]`, null);
  };

  const onSuccessNext = () => {
    props.onChange(2);
    window.scroll(0, 0);
  };

  const formikStep3 = useFormik({
    initialValues: {
      images: [],
      image_thumbnails: [],
      videos: [],
      upc_code: "",
      qr_code: "",
      bar_code: "",
    },
    validationSchema: yup.object({
      // images: yup.array().min(1),
    }),

    onSubmit: () => {
      //props.onChange(2);
      let foodId = [];
      for (let i = 0; i < formikStep2.values.food_type.length; i++) {
        foodId.push(formikStep2.values.food_type[i]._id);
      }

      // let imageNotAvailable = formikStep3.values.images;
      // let imageNotAvailable_Thumbnails = formikStep3.values.image_thumbnails;
      // if (formikStep3.values.images.length <= 0) {
      //   imageNotAvailable.push(DEFAULT_ITEM_IMAGE);
      //   imageNotAvailable_Thumbnails.push(DEFAULT_ITEM_IMAGE);
      //   formikStep3.setFieldValue("images", imageNotAvailable);
      //   formikStep3.setFieldValue(
      //     "image_thumbnails",
      //     imageNotAvailable_Thumbnails
      //   );
      // }

      const token = props.auth.user.accessToken;
      let formData = {};
      let image;
      formData = {
        ...formik.values,
        ...formikStep2.values,
        ...formikStep3.values,
      };
      let submitData = formData;
      if (productData) {
        delete submitData.primary_food_type;
      } else {
        delete submitData.primary_beverages_type;
      }

      if (
        props.menuCategoryItems.currentState !== 9 ||
        props.menuCategoryItems.runingTrack !== 9
      ) {
        formData.currentState = 1;
        formData.runingTrack = 2;
      }

      formData.food_type = foodId;

      if (props.activeItemId.length > 2) {
        props.update_item_menu_setup(
          props.activeItemId,
          formData,
          token,
          onSuccessNext
          // (err) => onError(err)
        );
      } else {
        props.create_new_item_menu_setup(
          formData,
          token,
          onSuccess,
          onErrorLast
        );
      }
    },
  });

  const onErrorLast = (err) => {
    if (err !== undefined) {
      Alert.error(`<h4>${err?.data?.message}</h4>`, {
        position: "top-right",
        effect: "bouncyflip",
        beep: true,
        html: true,
        timeout: 3000,
        offset: 35,
      });
    }
  };

  // const onError = (err) => {
  //   Alert.error(`<h4>${err?.response?.data?.message}</h4>`, {
  //     position: "top-right",
  //     effect: "bouncyflip",
  //     beep: true,
  //     html: true,
  //     timeout: 3000,
  //     offset: 35,
  //   });
  // };

  const Capitalize = (str, name) => {
    return formik.setFieldValue(
      name,
      str.charAt(0).toUpperCase() + str.slice(1)
    );
  };

  const titleCase = (str, name, e) => {
    e.preventDefault();
    str = str.toLowerCase().split(" ");
    for (var i = 0; i < str.length; i++) {
      str[i] = str[i].charAt(0).toUpperCase() + str[i].slice(1);
    }
    return formik.setFieldValue(name, str.join(" "));
  };

  const onSuccess = (data) => {
    let menuData = [];
    for (let i = 0; i < data.length; i++) {
      if (!data[i].is_temp_local)
        menuData.push({
          _id: data[i]._id,
          name: data[i].name,
        });
    }
    setMenuCategory(menuData);
  };

  useEffect(() => {
    const token = props.auth.user.accessToken;
    props.get_category_menu_setup_without_loader(token, onSuccess);
    props.get_menu_items(token, onSuccessLoadItems);
  }, []);
  // useEffect(() => {

  // }, [props.menuCategory]);

  useEffect(() => {
    let data = [];
    if (props && props.food_type) {
      for (let i = 0; i < props.food_type.length; i++) {
        if (props.food_type[i].status === "APPROVED") {
          data.push({
            _id: props.food_type[i]._id,
            title: props.food_type[i].title,
          });
        }
      }

      setFoodType(data);
    }
  }, [props.food_type]);

  useEffect(() => {
    let data = [];
    if (props && props?.allCategory?.beverages_type) {
      for (let i = 0; i < props?.allCategory?.beverages_type.length; i++) {
        if (props?.allCategory?.beverages_type[i].status === "APPROVED") {
          data.push({
            _id: props?.allCategory?.beverages_type[i]._id,
            title: props?.allCategory?.beverages_type[i].title,
          });
        }
      }
      setBeveragesType(data);
    }
  }, [props.allCategory]);

  useEffect(() => {
    let data = [];
    if (props && props.crusine) {
      for (let i = 0; i < props.crusine.length; i++) {
        if (props.crusine[i].status === "APPROVED") {
          data.push({
            _id: props.crusine[i]._id,
            title: props.crusine[i].title,
          });
        }
      }
      setCrusineType(data);
    }
  }, [props.crusine]);

  useEffect(() => {
    if (Object.entries(props.menuCategoryItems).length !== 0) {
      let data = props.menuCategoryItems;
      formik.setFieldValue("ext_id", data.ext_id);
      formik.setFieldValue("name", data.name);
      formik.setFieldValue("keywords", data.keywords);
      setKeywords(data.keywords);
      formik.setFieldValue("utterancesVoice", data.utterancesVoice);
      setUtterancesVoice(data.utterancesVoice);
      formik.setFieldValue("category", data.category);
      formik.setFieldValue("description", data.description);
      formik.setFieldValue(
        "ingredient_description",
        data.ingredient_description
      );
      formikStep2.setFieldValue("veg", data.veg);
      formikStep2.setFieldValue("itemType", data?.itemType);
      formikStep2.setFieldValue("primary_food_type", data.primary_food_type);
      formikStep2.setFieldValue(
        "primary_beverages_type",
        data.primary_beverages_type
      );
      formikStep2.setFieldValue("cuisin_type", data.cuisin_type);
      formikStep2.setFieldValue("prepTime", data.prepTime);
      formikStep3.setFieldValue("images", data.images);
      formikStep3.setFieldValue("videos", data.videos);
      formikStep3.setFieldValue("upc_code", data.upc_code);
      formikStep3.setFieldValue("bar_code", data.bar_code);
      formikStep3.setFieldValue("qr_code", data.qr_code);
    }
  }, [props.menuCategoryItems]);

  // useEffect(() => {
  //   if (Object.entries(props.menuCategoryItems).length !== 0) {
  //     let selectedFoodType = props.menuCategoryItems.food_type;
  //     let updateFoodType = [];
  //     let updateSelectedFoodType = [];
  //     for (let i = 0; i < foodType.length; i++) {
  //       if (selectedFoodType.includes(foodType[i]._id)) {
  //         updateSelectedFoodType.push({
  //           title: foodType[i].title,
  //           _id: foodType[i]._id,
  //         });
  //       } else {
  //         updateFoodType.push({
  //           title: foodType[i].title,
  //           _id: foodType[i]._id,
  //         });
  //       }
  //     }
  //     setFoodType(updateFoodType);
  //     setSelectedFoodType(updateSelectedFoodType);
  //   }
  // }, [foodType, props.menuCategoryItems]);

  useEffect(() => {
    if (
      props.productClassification === "Beverage" ||
      props.productClassification === "Alcoholic Beverage" ||
      props.productClassification === "Packed Beverage" ||
      props.productClassification === "Packed Alcoholic Beverage"
    ) {
      setProductData(true);
    } else {
      setProductData(false);
    }
    // let category = formik.values.category;
    // if (Object.entries(props.menuCategory).length !== 0) {
    //   let selectedFoodType = props.menuCategory;
    //   for (let i = 0; i < selectedFoodType.length; i++) {
    //     if (
    //       selectedFoodType[i].product_classification === "Beverage"
    //       // ||
    //       // selectedFoodType[i].product_classification === "Alcoholic Beverage" ||
    //       // selectedFoodType[i].product_classification === "Packed Beverage" ||
    //       // selectedFoodType[i].product_classification ===
    //       //   "Packed Alcoholic Beverage"
    //     ) {
    //       console.log("Working Beverages ==>");
    //       // setProductData(true);
    //     } else {
    //       console.log("Working Food Type ==>");
    //       // setProductData(false);
    //     }
    //   }
    // }
  }, [props?.productClassification]);

  const [dataForCopy, setDataForCopy] = useState({});

  const setItemForCopy = (item) => {
    setDataForCopy(item);
  };
  const [showExtId, setShowExtId] = useState(false);
  const handleCloseExtId = () => {
    setShowExtId(false);
  };

  const showExitId = () => {
    if (Object.entries(dataForCopy).length === 0) {
      Alert.error(`<h4> Please select item to copy</h4>`, {
        position: "top-right",
        effect: "bouncyflip",
        beep: true,
        html: true,
        timeout: 3000,
        offset: 35,
      });
    } else {
      setShowExtId(true);
    }
  };
  const [search, setSearch] = useState("");
  var filteredData = props.all_menu_items.filter((item) => {
    return (
      (item &&
        item.category &&
        item.category.name.toLowerCase().includes(search.toLowerCase())) ||
      (item && item.name.toLowerCase().includes(search.toLowerCase())) ||
      (item && item.description.toLowerCase().includes(search.toLowerCase())) ||
      (item && item.ext_id.toLowerCase().includes(search.toLowerCase()))
    );
  });

  filteredData = filteredData.filter((item) => {
    return item.is_temp_local === false || item.is_temp_local === undefined;
  });

  const copyItem = () => {
    formikCopyItem.handleSubmit();
  };

  const onSuccessCopyItem = () => {
    Alert.success(`<h4>Item copied sucessfully</h4>`, {
      position: "top-right",
      effect: "bouncyflip",
      beep: true,
      html: true,
      timeout: 3000,
      offset: 35,
    });
    if (
      props.auth.user.VendorUser.has_admin_approved &&
      props.auth.user.VendorUser.have_vendor_submitted_details
    ) {
      history.push("/menusetup-dashboard");
    } else {
      history.push("/casual-fine-dining/menusetup");
    }
  };

  const formikCopyItem = useFormik({
    initialValues: {
      ext_id: "",
    },
    // validationSchema: yup.object({
    //   ext_id: yup
    //     .string()
    //     .max(20, "Must be 20 characters or less")
    //     .required("Ext item id is required"),
    // }),

    onSubmit: (values) => {
      if (extIdData.includes(formikCopyItem.values.ext_id)) {
        Alert.error(
          `<h4> You have already assigned this ext id to another item</h4>`,
          {
            position: "top-right",
            effect: "bouncyflip",
            beep: true,
            html: true,
            timeout: 3000,
            offset: 35,
          }
        );
      } else {
        const formData = { ...dataForCopy };
        delete formData._id;
        delete formData.ext_id;
        formData.ext_id = "";
        formData.status = false;
        const token = props.auth.user.accessToken;
        props.create_new_item_menu_setup(
          formData,
          token,
          onSuccessCopyItem,
          onErrorLast
        );
      }
    },
  });

  const [extIdData, setExtIdData] = useState([]);
  const onSuccessLoadItems = (data) => {
    let listOfExtId = [];
    for (let i = 0; i < data.length; i++) {
      if (data[i].ext_id) {
        if (props.activeItemId === data[i]._id) {
        } else {
          listOfExtId.push(data[i].ext_id);
        }
      }
    }
    setExtIdData(listOfExtId);
  };
  const [showCopy, setShowCopy] = useState(false);
  const handleShowCopy = () => {
    // setLoading(true);
    // const token = props.auth.user.accessToken;
    // props.get_menu_items(token, onSuccessLoadItems);
    setShowCopy(true);
  };
  const handleCloseCopy = () => setShowCopy(false);

  useEffect(() => {
    if (transcript) {
      addUtterancesVoiceActionMic(transcript);
    }
  }, [transcript]);
  //slider settings
  const settings = {
    arrows: true,
    infinite: false,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 3,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
        },
      },
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };
  return (
    <React.Fragment>
      <Form>
        {step === 1 && (
          <React.Fragment>
            <Row>
              <Col xs={8}>
                <div className="mb-4 headingText">
                  <TopTextReusableComponent
                    headingText="New Item - Basic Info"
                    headingParagraph="Add basic information details"
                  />
                </div>
              </Col>
              <Col xs={4} className="text-right d-flex justify-content-end">
                <button
                  type="button"
                  className="enCopyItems"
                  onClick={handleShowCopy}
                >
                  <SVG
                    width="22px"
                    height="22px"
                    src={require("../../../../../../../assets/images/UserManagement/copy.svg")}
                  />
                  <div className="text-red f9-400 w-100">
                    Copy from Another Item From your menu
                  </div>
                </button>
              </Col>
            </Row>
            <div className="bg-gray px-3 py-2 AddItemsidFildMobile">
              <Row>
                <Col md={6}>
                  <div className="d-flex align-items-center">
                    <div className="f12-700 pr-3" style={{ width: 140 }}>
                      Ext Item ID :
                    </div>
                    <FormControl
                      className={"w-100 bg-white"}
                      variant="outlined"
                    >
                      <OutlinedInput
                        id="ext_id"
                        name="ext_id"
                        onChange={formik.handleChange}
                        value={formik.values.ext_id}
                        onKeyPress={(e) => {
                          if (e.which == 13) {
                            e.preventDefault();
                          }
                        }}
                      />
                      {formik.errors.ext_id && formik.touched.ext_id ? (
                        <div
                          className="pho_14_regular text-danger"
                          style={{
                            background: "#F3F3F3",
                          }}
                        >
                          {formik.errors.ext_id}
                        </div>
                      ) : null}
                    </FormControl>
                  </div>
                </Col>
                {/* <Col md={6}>
                  <div className="d-flex align-items-center">
                    <div className="f12-700 pr-3" style={{ width: 140 }}>
                      Global/Chain:
                      <br />
                      Item ID :
                    </div>
                    <FormControl
                      disabled={true}
                      className={"w-100 bg-white"}
                      variant="outlined"
                      onKeyPress={(e) => {
                        if (e.which == 13) {
                          e.preventDefault();
                        }
                      }}
                    >
                      <OutlinedInput
                        endAdornment={
                          <InputAdornment position="end">
                            <IconButton edge="end">
                              <SearchIcon />
                            </IconButton>
                          </InputAdornment>
                        }
                      />
                    </FormControl>
                  </div>
                </Col> */}
              </Row>
            </div>
            <div className="pt-3 mb-3 d-flex justify-content-between">
              <AddButtonIconComponent
                buttonText="Add Items using Global  Menu"
                fontIcon="fa fa-plus"
                colorCss="blue"
                onClick={(e) => takeToDashboard(e, 1)}
                style={{ margin: "0 !importnat", display: "inline" }}
              />
              <AddButtonIconComponent
                buttonText="Add Items using Chain Menu"
                fontIcon="fa fa-plus"
                colorCss="blue"
                onClick={(e) => takeToDashboard(e, 2)}
                style={{ margin: "0 !importnat", display: "inline" }}
              />
            </div>
            {/* <div className="pt-2 mb-3">
              
            </div> */}
            <Row>
              <Col md={8}>
                <NewInputText
                  controlClass={"name"}
                  labelText="Item Name*"
                  extraClass={`mb-1 w-100 ${
                    formik.errors.name && formik.touched.name ? "enError" : ""
                  }`}
                  name="name"
                  onKeyPress={(e) => {
                    if (e.which == 13) {
                      e.preventDefault();
                    }
                  }}
                  //onChange={formik.handleChange}
                  //onChange={(e) => Capitalize(e.target.value, "name")}
                  onChange={(e) => titleCase(e.target.value, "name", e)}
                  value={formik.values.name}
                  onFocusOut={formik.handleBlur}
                />
                <div className="f10-500 opacity5 mb-3">
                  * Maximum 50 characters
                </div>
                {formik.errors.name && formik.touched.name ? (
                  <div className="pho_14_regular text-danger">
                    {formik.errors.name}
                  </div>
                ) : null}
              </Col>
            </Row>
            <Row>
              <div className="mt-3 pl-3 col-sx-8">
                <div className=" onboarding-restaurant-details-margin">
                  <div className="row align-items-center">
                    <div className="col-12">
                      <NewInputText
                        extraClass="mb-1"
                        name="utterancesVoiceText"
                        onChange={onUtterancesVoiceChangeHandler}
                        value={utterancesVoiceText}
                        labelText="Utterances for Voice"
                      />
                      <div className="MuiFormHelperText-root MuiFormHelperText-root Mui-error ">
                        {errors.utterancesVoiceText !== ""
                          ? errors.utterancesVoiceText
                          : "* Manage the utterances for the food item"}
                      </div>
                      <div className="opacity5 f10-400">
                        * Manage the utterances for the food item
                        {/* <p>
                                  {transcript
                                    ? transcript
                                    : "Start listening for transcript"}
                                </p> */}
                      </div>
                    </div>
                    {/* <div className="col-5">
                                  <AddButtonIconComponent
                                    buttonText="Add More Utterances Voice"
                                    onClick={addUtterancesVoiceAction}
                                    fontIcon="fa fa-plus"
                                    colorCss="blue"
                                  />
                                </div> */}
                  </div>
                </div>
              </div>
              <Col md={4} xs={5} className="mt-3">
                <Button
                  variant="secondary"
                  onClick={SpeechRecognition.startListening}
                >
                  <div
                    style={{
                      position: "relative",
                      top: "-8px",
                      left: "50px",
                    }}
                  >
                    <AddButtonIconComponent
                      onClick={addUtterancesVoiceAction}
                      fontIcon="fa fa-plus"
                      colorCss="blue"
                    />
                  </div>
                  <SVG
                    src={require("../../../../../../../assets/images/UserManagement/microphone.svg")}
                    width="22px"
                    height="30px"
                  />
                </Button>
                <div
                  className="f10-400 mt-2"
                  style={{ color: "#2096F3" }}
                  onClick={addUtterancesVoiceAction}
                >
                  Add Utterances
                </div>
                <FormControl variant="outlined">
                  <Select
                    labelId="demo-customized-select-label"
                    id="demo-customized-select"
                    value={"EN -English"}
                    // onChange={handleChange}
                  >
                    <MenuItem value="EN -English">EN -English</MenuItem>
                  </Select>
                </FormControl>
              </Col>
              {utterancesVoice && utterancesVoice.length > 0 ? (
                <Col md={6} className="mt-3">
                  <div className="col-12 p-0 onboarding-restaurant-details-margin">
                    <div className="row enChipBox border-0">
                      {/* <Scrollbars
                                  style={{ width: "100%", height: 135 }}
                                > */}
                      {utterancesVoice &&
                        utterancesVoice.map((data, index) => {
                          return (
                            <div className="mb-3 mr-3" key={index}>
                              <div className="keywords_button">
                                <p>{data}</p>
                                <span
                                  className="ml-2"
                                  onClick={removeUtterancesVoiceAction(index)}
                                >
                                  <SVG
                                    src={require("../../../../../../../assets/images/UserManagement/close.svg")}
                                  />
                                </span>
                              </div>
                            </div>
                          );
                        })}
                      {/* </Scrollbars> */}
                    </div>
                  </div>
                </Col>
              ) : (
                ""
              )}
            </Row>
            <Row>
              <Col md={12} className="mt-3">
                <div className=" onboarding-restaurant-details-margin">
                  <div className="row align-items-center">
                    <div className="col-8">
                      <NewInputText
                        extraClass="mb-1"
                        name="keywordsText"
                        onChange={onKeywordsChangeHandler}
                        value={keywordsText}
                        labelText="Keywords"
                      />
                      <div className="MuiFormHelperText-root MuiFormHelperText-root Mui-error ">
                        {errors.keywordsText}
                      </div>
                    </div>
                    <div className="col-4">
                      <AddButtonIconComponent
                        buttonText="Add More Keywords"
                        onClick={addKeywordsAction}
                        fontIcon="fa fa-plus"
                        colorCss="blue"
                      />
                    </div>
                  </div>
                </div>
              </Col>
              <Col xs={6} className="mt-3">
                {keywords && keywords.length > 0 ? (
                  <div className="col-12 p-0 onboarding-restaurant-details-margin">
                    <div className="enChipBox border-0">
                      <Scrollbars style={{ width: "100%", height: 135 }}>
                        {keywords &&
                          keywords.map((data, index) => {
                            return (
                              <div className="mb-3 mr-3" key={index}>
                                <div className="keywords_button">
                                  <p>{data}</p>
                                  <span
                                    className="ml-2"
                                    onClick={removeKeywordsAction(index)}
                                  >
                                    <SVG
                                      src={require("../../../../../../../assets/images/UserManagement/close.svg")}
                                    />
                                  </span>
                                </div>
                              </div>
                            );
                          })}
                      </Scrollbars>
                    </div>
                    <div className="opacity5 f10-400">
                      ( Your keywords for the food item will help people find
                      the item with ease )
                    </div>
                  </div>
                ) : (
                  ""
                )}
              </Col>
              {/* <Col md={4} className="mt-3">
                    <Button
                      variant="danger"
                      onClick={SpeechRecognition.startListening}
                    >
                      <SVG
                        src={require("../../../../../../../assets/images/UserManagement/microphone.svg")}
                        width="22px"
                        height="30px"
                      />
                    </Button>
                  </Col> */}
            </Row>
            <Form.Label className="f14-500 mb-1 mt-4">Menu Category</Form.Label>
            <div className="f10-500 opacity5 mb-3">Select Category*</div>
            <div
              className="row col-12 d-flex column-2 align-items-center"
              style={{
                border: "2px solid #e6e6e6",
                overflowY: "scroll",
                maxHeight: "232px",
                paddingTop: "2vh",
                borderRadius: "6px",
              }}
            >
              {menuCategory.map((menu, index) => (
                <div
                  className="position-relative col-md-4 col-6 mr-0"
                  key={index}
                  onClick={() => onChangeMenuCategory(menu._id)}
                >
                  <div
                    className={`mb-3 mr-3 onboarding_mapbutton_reusable justify-content-between onboarding_mapbutton_reusable_type ${
                      formik.values.category === menu._id
                        ? "onboarding_mapbutton_reusable_active_two"
                        : ""
                    }`}
                  >
                    <div className="d-flex align-items-center">
                      <img
                        src={
                          "https://amealia.s3.amazonaws.com/categoryicons/superadminCategoryicon-180-0013.png"
                        }
                        alt="icon"
                        title="Soups"
                      />

                      <span style={{ fontSize: "2vh" }}>{menu.name}</span>
                    </div>
                  </div>
                </div>
              ))}

              {/* <div className="position-relative">
                <div
                  className={
                    "mb-3 mr-3 onboarding_mapbutton_reusable justify-content-between onboarding_mapbutton_reusable_type onboarding_mapbutton_reusable_active"
                  }
                >
                  <div className="d-flex align-items-center">
                    <img
                      src={
                        "https://amealia.s3.amazonaws.com/categoryicons/superadminCategoryicon-180-0013.png"
                      }
                      alt="icon"
                      title="Starters"
                    />

                    <span className="para-data-icon">Starters</span>
                  </div>
                </div>
              </div> */}
            </div>
            {formik.errors.category && formik.touched.category ? (
              <div className="pho_14_regular text-danger">
                {formik.errors.category}
              </div>
            ) : null}
            <Row className="mt-4">
              <Col md={8}>
                <NewInputText
                  controlClass={"description"}
                  labelText="Item Details*"
                  extraClass={`w-100 mb-0 ${
                    formik.errors.description && formik.touched.description
                      ? "enError"
                      : ""
                  }`}
                  multiline={true}
                  rows="5"
                  name="description"
                  //onChange={formik.handleChange}
                  onChange={(e) => Capitalize(e.target.value, "description")}
                  value={formik.values.description}
                />
                {formik.errors.description && formik.touched.description ? (
                  <div className="pho_14_regular text-danger">
                    {formik.errors.description}
                  </div>
                ) : null}
              </Col>
              <Col md={8} className="mt-4" style={{ marginBottom: "40px" }}>
                <NewInputText
                  labelText="Ingredients List*"
                  extraClass="mb-0 w-100"
                  multiline={true}
                  rows="5"
                  name="ingredient_description"
                  //onChange={formik.handleChange}
                  onChange={(e) =>
                    Capitalize(e.target.value, "ingredient_description")
                  }
                  value={formik.values.ingredient_description}
                />
                {formik.errors.ingredient_description &&
                formik.touched.ingredient_description ? (
                  <div className="pho_14_regular text-danger">
                    {formik.errors.ingredient_description}
                  </div>
                ) : null}
              </Col>
              {/* <Col md={8} className="mt-3">
                <div className=" onboarding-restaurant-details-margin">
                  <div className="row align-items-center">
                    <div className="col-9">
                      <NewInputText
                        extraClass="mb-1"
                        name="keywordsText"
                        onChange={onKeywordsChangeHandler}
                        value={keywordsText}
                        labelText="Keywords"
                        onKeyPress={(e) => {
                          if (e.which == 13) {
                            e.preventDefault();
                          }
                        }}
                      />
                      <div className="f10-500 opacity5 mb-3">
                        (Your keywords for the food item will help people find
                        the item with ease )
                      </div>
                      <div className="MuiFormHelperText-root MuiFormHelperText-root Mui-error ">
                        {errors.keywordsText}
                      </div>
                    </div>
                    <div className="col-3">
                      <AddButtonIconComponent
                        buttonText="Add  Keywords"
                        onClick={addKeywordsAction}
                        fontIcon="fa fa-plus"
                        colorCss="blue"
                      />
                    </div>
                  </div>
                </div>
              </Col> */}
            </Row>
            <div className="onboarding-map-setup-screen-autodetect-button mt-5">
              <ReusableOnboardingButton
                buttonTitle="Back Button"
                buttonClass="btn-lg btn btn-outline-secondary"
                buttonText="Back"
                buttonType="button"
                buttonStyle={{ minWidth: "150px" }}
                onClick={(e) => takeToDashboard(e, 0)}
                // onClick={() =>
                //   props.history.push("/casual-fine-dining/menusetup")
                // }
              />
              <ReusableOnboardingButton
                buttonTitle="Next Button"
                buttonClass="btn-lg btn btn-danger btn-lg ml-3 "
                buttonText="Save and Next"
                buttonType="button"
                buttonStyle={{ minWidth: "150px" }}
                onClick={(e) => onClickStep2(e)}
                // onClick={() => handleStepChange(2)}
              />
            </div>
          </React.Fragment>
        )}
        {step === 2 && (
          <React.Fragment>
            <div className="mb-4 headingText">
              <TopTextReusableComponent
                headingText="New Item - Characteristics"
                headingParagraph="Manage your food items"
              />
            </div>
            <div className="bg-gray px-3 py-2 AddItemsidFildMobile">
              <Row>
                <Col md={6}>
                  <div className="d-flex align-items-center">
                    <div className="f12-700 pr-3" style={{ width: 140 }}>
                      Ext Item ID :
                    </div>
                    <FormControl
                      className={"w-100 bg-white"}
                      variant="outlined"
                    >
                      <OutlinedInput disabled value={formik.values.ext_id} />
                    </FormControl>
                  </div>
                </Col>
                {/* <Col md={6}>
                  <div className="d-flex align-items-center">
                    <div className="f12-700 pr-3" style={{ width: 140 }}>
                      Global/Chain:
                      <br />
                      Item ID :
                    </div>
                    <FormControl
                      className={"w-100 bg-white"}
                      variant="outlined"
                    >
                      <OutlinedInput
                        endAdornment={
                          <InputAdornment position="end">
                            <IconButton edge="end">
                              <SearchIcon />
                            </IconButton>
                          </InputAdornment>
                        }
                      />
                    </FormControl>
                  </div>
                </Col> */}
              </Row>
            </div>
            <div
              className="displayItemsName f11-400 enRadius5 my-4"
              style={{ height: 50 }}
            >
              {formik.values.name}
            </div>
            {productData ? (
              <>
                {/********************************
                 * @DESC Beverage Type Category
                 *********************************/}
                <div className="f14-700 mb-3">Beverages Type*</div>
                <div className="restaurant_type_onboarding_main smallCenter">
                  <div className="cuisine-main mt-0">
                    <div className={"cuisine-main-padding-border"}>
                      <div
                        id="box-style"
                        className="cuisine-main-padding column-2 justify-content-start"
                        style={{
                          display: "flex",
                          flexWrap: "wrap",
                          overflow: "scroll",
                        }}
                      >
                        {beveragesType.map((icon, index) => (
                          <ReusableOnboardingMapButton
                            key={index}
                            classsection={
                              // state.selected_food_type.includes(icon)
                              formikStep2.values.beverages_type.includes(icon)
                                ? "onboarding_mapbutton_reusable onboarding_mapbutton_reusable_type "
                                : "onboarding_mapbutton_reusable onboarding_mapbutton_reusable_type"
                            }
                            onClick={() =>
                              onClickAddBeveragesType(icon.title, icon._id)
                            }
                            title={icon.title}
                          />
                        ))}
                      </div>
                      {formikStep2.errors.beverages_type ? (
                        <div className="pho_14_regular text-danger">
                          {formikStep2.errors.beverages_type}
                        </div>
                      ) : null}
                    </div>
                    {selectedBeveragesType.length > 0 ? (
                      <>
                        <div className="f14-700 ">
                          Out of the selections below, which one is primary?
                        </div>

                        <div className="f12-400 mb-3 opacity5">
                          Select only one of the options below as a default -
                          this is shown to the user .
                        </div>
                      </>
                    ) : (
                      <> </>
                    )}
                    <div
                      className="cuisine-main-padding-bottom column-2 justify-content-start mobile-device-bottom-margin mt-4"
                      style={{ display: "flex", flexWrap: "wrap" }}
                    >
                      {selectedBeveragesType.map((icon, index) => (
                        <ReusableOnboardingMapButton
                          key={index}
                          classsection={
                            formikStep2.values.primary_beverages_type ===
                            icon._id
                              ? "onboarding_mapbutton_reusable onboarding_mapbutton_reusable_active_two onboarding_mapbutton_reusable_type"
                              : "onboarding_mapbutton_reusable onboarding_mapbutton_reusable_type onboarding_mapbutton_reusable_active"
                          }
                          //src={icon.icon}
                          title={icon.title}
                          onClick={() => setPrimaryBeveragesType(icon._id)}
                          displayPrimary={
                            formikStep2.values.primary_beverages_type ===
                            icon._id
                              ? true
                              : false
                          }
                          displayRemove={true}
                          removeButtonClick={() =>
                            removeBeveragesType(icon.title, icon._id)
                          }
                        />
                      ))}
                    </div>
                    {console.log(
                      "error ==>",
                      formikStep2.errors.primary_beverages_type
                    )}
                    <div id="focusPrimaryBeverages">
                      {/*{formikStep2.values.beverages_type.length !== 0 ? ( */}
                      <div tabIndex="0">
                        {formikStep2.errors.primary_beverages_type &&
                        formikStep2.touched.primary_beverages_type ? (
                          <div className="pho_14_regular text-danger">
                            {formikStep2.errors.primary_beverages_type}
                          </div>
                        ) : null}
                      </div>
                      {/* ) : (
                        <> </>
                      )} */}
                    </div>
                  </div>
                </div>
              </>
            ) : (
              <>
                <div className="f14-700 mb-3">Please Select</div>
                <div className="row checkbox-bank-account justify-content-start mb-4">
                  {ITEMTYPEVEG.map((type, index) => {
                    return (
                      <div className="col-4 col-sm-4 col-md-3" key={index}>
                        <label className="enRadioWithText small">
                          <span className="f12-500">{type.title}</span>
                          <input
                            id="itemType"
                            type="radio"
                            name="itemType"
                            value={
                              formikStep2.values.itemType === type.value
                                ? true
                                : false
                            }
                            onChange={() => itemTypeAction(type.value)}
                            checked={
                              formikStep2.values.itemType === type.value
                                ? true
                                : false
                            }
                          />
                          <span className="checkmark"></span>
                        </label>
                      </div>
                    );
                  })}
                  {formikStep2.errors.itemType &&
                  formikStep2.touched.itemType ? (
                    <div className="pho_14_regular text-danger">
                      {formikStep2.errors.itemType}
                    </div>
                  ) : null}
                </div>
                {/********************************
                 * @DESC Food Type Category
                 *********************************/}
                <div className="f14-700 mb-3">Food Type</div>
                <div className="restaurant_type_onboarding_main smallCenter">
                  <div className="cuisine-main mt-0">
                    <div
                    // className={
                    // state.all_food_type.length > 8
                    //   ?
                    // "cuisine-main-padding-border"
                    //   : ""
                    // }
                    >
                      <div
                        id="box-style"
                        className="cuisine-main-padding column-2 justify-content-start"
                        style={{
                          display: "flex",
                          flexWrap: "wrap",
                          overflow: "scroll",
                        }}
                      >
                        {foodType.map((icon, index) => (
                          <ReusableOnboardingMapButton
                            key={index}
                            classsection={
                              state.selected_food_type.includes(icon)
                                ? "onboarding_mapbutton_reusable onboarding_mapbutton_reusable_type "
                                : "onboarding_mapbutton_reusable onboarding_mapbutton_reusable_type"
                            }
                            onClick={() =>
                              onClickAddFoodType(icon.title, icon._id)
                            }
                            //src={icon.icon}
                            title={icon.title}
                            //   onClick={onRestaurantFoodTypeArraySelector(
                            //     icon,
                            //     index
                            //   )}
                          />
                        ))}
                        <div className="position-relative mt-3 col-md-4 col-5">
                          <div className="p-0">
                            <div className="suggest-button-heading">
                              <SuggestNewButton
                                categoryId={"5f562c9094ac7fdf47ea1d1d"}
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                      {formikStep2.errors.food_type ? (
                        <div className="pho_14_regular text-danger">
                          {formikStep2.errors.food_type}
                        </div>
                      ) : null}
                    </div>
                    {selectedFoodType.length > 0 ? (
                      <>
                        <div className="f14-700 ">
                          Out of the selections below, which one is primary?
                        </div>

                        <div className="f12-400 mb-3 opacity5">
                          Select only one of the options below as a default -
                          this is shown to the user .
                        </div>
                      </>
                    ) : (
                      <> </>
                    )}
                    <div
                      className="cuisine-main-padding-bottom column-2 justify-content-start mobile-device-bottom-margin mt-4"
                      style={{ display: "flex", flexWrap: "wrap" }}
                    >
                      {selectedFoodType.map((icon, index) => (
                        <ReusableOnboardingMapButton
                          key={index}
                          classsection={
                            formikStep2.values.primary_food_type === icon._id
                              ? "onboarding_mapbutton_reusable onboarding_mapbutton_reusable_active_two onboarding_mapbutton_reusable_type"
                              : "onboarding_mapbutton_reusable onboarding_mapbutton_reusable_type onboarding_mapbutton_reusable_active"
                          }
                          //src={icon.icon}
                          title={icon.title}
                          onClick={() => setPrimaryFoodType(icon._id)}
                          displayPrimary={
                            formikStep2.values.primary_food_type === icon._id
                              ? true
                              : false
                          }
                          displayRemove={true}
                          removeButtonClick={() =>
                            removeFoodType(icon.title, icon._id)
                          }
                        />
                      ))}
                    </div>
                    <div id="focusPrimary">
                      {formikStep2.values.food_type.length !== 0 ? (
                        <div tabIndex="0">
                          {formikStep2.errors.primary_food_type &&
                          formikStep2.touched.primary_food_type ? (
                            <div className="pho_14_regular text-danger">
                              {formikStep2.errors.primary_food_type}
                            </div>
                          ) : null}
                        </div>
                      ) : (
                        <> </>
                      )}
                    </div>
                  </div>
                </div>
              </>
            )}

            <div className="f14-700 mb-3">Cuisine Type</div>
            <div className="mb-1 d-flex flex-wrap radioColumn-2">
              {cruisneType.map((item, index) => (
                <div className="enCheckWithText small" key={index}>
                  <input
                    id="cuisin_type"
                    type="radio"
                    name="cuisin_type"
                    value={item._id}
                    onChange={formikStep2.handleChange}
                    checked={formikStep2.values.cuisin_type === item._id}
                  />
                  <label className="w-100 d-flex align-items-center justify-content-center">
                    {item.title}
                  </label>
                </div>
              ))}
            </div>

            {formikStep2.errors.cuisin_type &&
            formikStep2.touched.cuisin_type ? (
              <div className="mb-3 pho_14_regular text-danger">
                {formikStep2.errors.cuisin_type}
              </div>
            ) : (
              <div className="mb-3"> </div>
            )}
            <div className="f14-700 mb-3">Preparation Time</div>
            <div className="mb-1 d-flex flex-wrap radioColumn-2">
              {preperationTime.map((item, index) => (
                <div className="enCheckWithText small" key={index}>
                  <input
                    id="prepTime"
                    type="radio"
                    name="prepTime"
                    value={item.name}
                    onChange={formikStep2.handleChange}
                    checked={formikStep2.values.prepTime == item.name}
                  />
                  <label className="w-100 d-flex align-items-center justify-content-center">
                    {item.name} Minutes
                  </label>
                </div>
              ))}
            </div>
            {formikStep2.errors.prepTime && formikStep2.touched.prepTime ? (
              <div className="mb-3 pho_14_regular text-danger">
                {formikStep2.errors.prepTime}
              </div>
            ) : (
              <div className="mb-3"> </div>
            )}
            <div className="onboarding-map-setup-screen-autodetect-button mt-5">
              <ReusableOnboardingButton
                buttonTitle="Back Button"
                buttonClass="btn-lg btn btn-outline-secondary"
                buttonText="Back"
                buttonType="button"
                onClick={() => handleStepChange(1)}
              />
              <ReusableOnboardingButton
                buttonTitle="Next Button"
                buttonClass="btn-lg btn btn-danger btn-lg ml-3 "
                buttonText="Save and Next"
                buttonType="button"
                //onClick={() => handleStepChange(3)}
                onClick={(e) => onClickStep3(e)}
              />
            </div>
          </React.Fragment>
        )}
        {step === 3 && (
          <React.Fragment>
            <div className="mb-4 headingText">
              <TopTextReusableComponent
                headingText="New Item - Images and Videos"
                headingParagraph="Manage your food items"
              />
            </div>
            <div className="bg-gray px-3 py-2 AddItemsidFildMobile">
              <Row>
                <Col md={6}>
                  <div className="d-flex align-items-center">
                    <div className="f12-700 pr-3" style={{ width: 140 }}>
                      Ext Item ID :
                    </div>
                    <FormControl
                      className={"w-100 bg-white"}
                      variant="outlined"
                    >
                      <OutlinedInput disabled value={formik.values.ext_id} />
                    </FormControl>
                  </div>
                </Col>
                {/* <Col md={6}>
                  <div className="d-flex align-items-center">
                    <div className="f12-700 pr-3" style={{ width: 140 }}>
                      Global/Chain:
                      <br />
                      Item ID :
                    </div>
                    <FormControl
                      className={"w-100 bg-white"}
                      variant="outlined"
                    >
                      <OutlinedInput
                        endAdornment={
                          <InputAdornment position="end">
                            <IconButton edge="end">
                              <SearchIcon />
                            </IconButton>
                          </InputAdornment>
                        }
                      />
                    </FormControl>
                  </div>
                </Col> */}
              </Row>
            </div>
            <div
              className="displayItemsName f11-400 enRadius5 my-4"
              style={{ height: 50 }}
            >
              {formik.values.name}
            </div>
            <div className="f20_700_HelveticaNeue mobile-f16-700">
              Upload Images, Videos and Other Attributes
            </div>
            <Form.Group className="pt-2 pt-md-4">
              {/* <Form.Label className="f14-500 mb-1">Upload Images</Form.Label> */}
              <div className="">
                {/* <div className="enUploadBox">
                  <Image
                    src={require("../../../../../../../assets/images/UserManagement/uploadImg.svg")}
                    alt="uploadImg"
                    title="uploadImg"
                    fluid
                  />
                  <input
                    type="file"
                    accept=".png, .jpg, .jpeg"
                    onChange={uploadImage}
                  />
                </div>
                {file && (
                  <div className="enIconUploaded">
                    <button
                      type="button"
                      className="enCloseButton"
                      onClick={() => setFile(null)}
                    >
                      <Image
                        src={require("../../../../../../../assets/images/UserManagement/en_close.svg")}
                        alt="uploadImg"
                        title="uploadImg"
                        fluid
                      />
                    </button>
                    <Image
                      src={file}
                      alt="icon"
                      title="icon"
                      className=""
                      fluid
                    />
                  </div>
                )} */}

                <SimpleReactLightbox>
                  <MultipleImageUploadComponent
                    title="Upload Item Images"
                    // smallTitle="(Upload supporting documents such as a Cancelled Cheque, Bank Statement as applicable) - You may receive a call for KYC and Confirmation"
                    onChange={bankUploadMultipleFiles}
                    //stateValue={bank_informaion}
                    stateValue={formikStep3.values.images}
                    newUploaded={
                      restaurant_pictures_new ? restaurant_pictures_new : []
                    }
                    combined={combined}
                    onCompleteUploadMultipleCrop={onCompleteUploadMultipleCrop}
                    cancelFiles={cancelFiles}
                    removeImage={bankDocMultipleRemove}
                    accept="image/gif,image/jpeg,image/jpg,image/png,.pdf"
                    // loader={state.bankImageLoader}
                    thumbnail={thumbnail}
                  />
                </SimpleReactLightbox>
              </div>
              {formikStep3.errors.images && formikStep3.touched.images ? (
                <div className="mb-3 pho_14_regular text-danger">
                  {formikStep3.errors.images}
                </div>
              ) : (
                <div className="mb-3"> </div>
              )}
              <div className="font_12_r c_gray mb-4 mt-3">
                <LearnMore
                  preText={
                    <>
                      Only .jpg and .png files. 500kb max file size. <br />
                      <br /> (You can add upto 6-10 pictures)
                    </>
                  }
                  mainContent={
                    <div className="f14-400">
                      <div className="f16-500">Menu Photos</div>
                      <br />
                      Diners rely comprehensively on the menus on Amealio when
                      deciding on where to eat or what to order, and to know the
                      pricing /costs of the items. <br />· For menu pages, the
                      maximum dimensions that can be uploaded are 650×700
                      pixels. <br />· Only the relevant text portion of the menu
                      is kept on the page <br />· A certain order for menu pages
                      is maintained identical to the way a user would read
                      through a menu: [Appetizers/soups] — [Starters] — [Main
                      course] — [Desserts] <br />· The menu must include the
                      names of the dishes and prices, as this helps Users to get
                      an idea about how much they will spend at the restaurant.
                      Avoid putting up menus without prices as it affects the
                      decision of a User. Photos of Food Items · The image
                      should have high resolution (images with 1200×500 pixels
                      or greater in resolution) <br />· The photo needs to be
                      visually appealing.  We currently only support .JPEG and
                      .PNZ file formats for photo uploads. · Photos of raw
                      ingredients are not allowed, unless that is the way the
                      food is served. <br />· Please do not add superimposed
                      logos to the photos. However, in-content branding, such as
                      logos on boxes, walls, crockery, etc. is allowed.   <br />
                      · Stock images aren’t allowed, so please choose food and
                      ambiance images which depict your restaurant.   <br />·
                      Please note violation of the below-mentioned points may
                      lead to reduced visibility, or deletion of your
                      Images/Photos  - Photos that are exact duplicates of other
                      photos, multiple clicks of the same dish or ambiance or
                      taken from different angles  - Plagiarized photos  -
                      Photos of others posted without their permission  - Photos
                      that contain promotional content  - Photos that contain
                      subject such as people in it  - Photos that are blurry or
                      unclear  - Photos that contain text, or are not related to
                      dine-in experience  - Photos of half-eaten food items  -
                      Photos of packed food items/packaging  - Photos of food
                      under preparation  - Photos containing watermarks or
                      write-ups of any kind  - Photos containing and focusing on
                      subjects other than food or restaurant ambiance  -
                      Unpleasant photos that ruin people's appetites  - No
                      images from other sources. No images that infringe on any
                      copyright, trademark, or other legal property rights
                    </div>
                  }
                />
              </div>
            </Form.Group>
            <Form.Group className="">
              <Form.Label className="f14-500 mb-2">Upload Videos</Form.Label>
              <div className="d-flex flex-wrap">
                <div className="enUploadBox">
                  <Image
                    src={require("../../../../../../../assets/images/UserManagement/uploadImg.svg")}
                    alt="uploadImg"
                    title="uploadImg"
                    fluid
                  />
                  <input type="file" accept=".mp4" onChange={uploadVideo} />
                </div>
                {formikStep3.values.videos.length > 0 && (
                  <Slider
                    {...settings}
                    className={`sliderUploadImges video-upload`}
                    // style={videoUpload && { width: "226px" }}
                  >
                    <div className="enIconUploaded">
                      <button
                        type="button"
                        className="enCloseButton"
                        onClick={() => removeVideo()}
                      >
                        <Image
                          src={require("../../../../../../../assets/images/UserManagement/en_close.svg")}
                          alt="removeVideo"
                          title="removeVideo"
                          fluid
                        />
                      </button>
                      <video width="100%" height="100%" controls>
                        <source
                          src={formikStep3.values.videos[0]}
                          type="video/mp4"
                        />
                        Your browser does not support the video tag.
                      </video>
                    </div>
                  </Slider>
                )}
              </div>
            </Form.Group>
            {!progress && progress === 0 ? null : (
              <AlertDialogProgress
                progress={progress}
                title="Video Uploading..."
              />
            )}
            <div className="font_12_r c_gray mb-4">
              <LearnMore
                preText={<>(You can add upto 6 videos) </>}
                mainContent={
                  <div className="f14-400">
                    <div className="f16-500">Menu Videos</div>
                    <br />
                    · The videos should have high resolution <br />· The videos
                    need to be visually appealing.   <br />· Avoid uploading
                    Videos that are blurry or unclear or that are not related or
                    relevant to dine-in experience <br />· We do not put up
                    videos which contain obscene, foul, etc. characters which
                    might be unpleasant to the diners <br />· We do not upload
                    videos that are made for spam and deceptive practices <br />
                    · We do not upload videos that contain Sensitive content -
                    includes child safety, nudity and sexual content, etc.{" "}
                    <br />· We do not put up ambiance/food video that is stock
                    video, or taken from Google videos/other websites. <br />·
                    No videos from other sources. No videos that infringe on any
                    copyright, trademark, or other legal property rights.
                  </div>
                }
              />
            </div>
            {product_classification !== "Food" &&
              product_classification !== "Beverage" && (
                <React.Fragment>
                  <Form.Label className="f18-500 mb-3">
                    Other Details only for Packed Items
                  </Form.Label>
                  <Row>
                    <Col md={6}>
                      <NewSelectBoxInput
                        selectLabel="Country*"
                        name="country"
                        value={state.countryOrigin}
                        onChange={selecthandleChange}
                        getCountries={getCountries}
                        en={en}
                        // errorText={errors.country}
                        // errorTrue={errors.country === "" ? true : false}
                      />
                    </Col>
                  </Row>
                  <Row>
                    <Col md={6}>
                      <NewInputText
                        labelText="UPC Code"
                        extraClass="mb-3 w-100"
                        name="upc_code"
                        onChange={formikStep3.handleChange}
                        value={formikStep3.values.upc_code}
                      />
                    </Col>
                    <Col md={6}>
                      <NewInputText
                        labelText="Bar Code"
                        extraClass="mb-3 w-100"
                        name="bar_code"
                        onChange={formikStep3.handleChange}
                        value={formikStep3.values.bar_code}
                      />
                    </Col>
                    <Col md={6}>
                      <NewInputText
                        labelText="FSSAI Code"
                        extraClass="mb-3 w-100"
                        name="qr_code"
                        onChange={formikStep3.handleChange}
                        value={formikStep3.values.qr_code}
                      />
                    </Col>
                  </Row>
                </React.Fragment>
              )}

            <div className="onboarding-map-setup-screen-autodetect-button mt-5">
              <ReusableOnboardingButton
                buttonTitle="Back Button"
                buttonClass="btn-lg btn btn-outline-secondary"
                buttonText="Back"
                buttonType="button"
                onClick={() => handleStepChange(2)}
              />
              <ReusableOnboardingButton
                buttonTitle="Next Button"
                buttonClass="btn-lg btn btn-danger btn-lg ml-3 "
                buttonText="Save and Next"
                buttonType="button"
                onClick={(e) => onSubmit(e)}
              />
            </div>
          </React.Fragment>
        )}
      </Form>
      <Modal
        show={showCopy}
        onHide={handleCloseCopy}
        centered
        className="xl-width-750 selectCatalogueModal"
      >
        <Modal.Header className="px-4 border-0" closeButton>
          <div className="w-100">
            <Modal.Title className="f20-700 pb-2">
              Search or Select Item to Copy
            </Modal.Title>
            <NewInputText
              labelText="Search By item name , category name , ext id or description"
              extraClass={`my-3 w-100 `}
              value={search}
              onChange={(e) => setSearch(e.target.value)}
            />
            {/* <NewInputText
                  labelText="Search By Item ID"
                  extraClass={`mb-3 w-100 `}
                /> */}
          </div>
        </Modal.Header>
        <Modal.Body className="px-4">
          <div className="enGrayBorderBox py-2">
            <Scrollbars style={{ width: "100%", height: 280 }}>
              <Row className="m-1">
                <Col xs={3} className="pr-0">
                  <div className="f16-700 mobile-f10-700">Item Code</div>
                </Col>
                <Col xs={4}>
                  <div className="f16-700 mobile-f10-700">Description</div>
                </Col>
                <Col xs={3} className="pl-0">
                  <div className="f16-700 mobile-f10-700">Category</div>
                </Col>
                <Col xs={2} className="pl-0">
                  <div className="f16-700 mobile-f10-700">Select</div>
                </Col>
              </Row>
              {filteredData.map((item, index) => (
                <Row className="m-0 pt-2" key={index}>
                  <Col xs={3} className="pr-0">
                    <div className="f14-400 mobile-f10-400">
                      {item.ext_id ? item.ext_id : "N/A"}
                    </div>
                  </Col>
                  <Col xs={4}>
                    <div className="f14-400 mobile-f10-400">
                      {item && item.description}
                    </div>
                  </Col>
                  <Col xs={3} className="pl-0">
                    <div className="f14-400 mobile-f10-400">
                      {item && item.category && item.category.name}
                    </div>
                  </Col>
                  <Col xs={2} className="pl-0">
                    <label className="enRadioWithText small">
                      <input
                        type="radio"
                        name="ItemCode"
                        onClick={() => setItemForCopy(item)}
                      />
                      <span className="checkmark"></span>
                    </label>
                  </Col>
                </Row>
              ))}
            </Scrollbars>
          </div>
          <div className="d-flex mobile-center align-items-center py-4">
            <Button
              variant="outline-secondary"
              className="btn150px btn-lg mr-4 px-5"
              onClick={() => setShowCopy(false)}
            >
              Cancel
            </Button>
            <Button
              variant="danger"
              className="btn150px btn-lg px-5"
              //onClick={() => showExitId()}
              onClick={() => copyItem()}
            >
              Select
            </Button>
          </div>
        </Modal.Body>
      </Modal>

      <Modal show={showExtId} onHide={handleCloseExtId} centered>
        <Modal.Header className="py-0 pt-2 border-0" closeButton>
          <Modal.Title>Enter Ext Id</Modal.Title>
        </Modal.Header>
        <Modal.Body className="f16-500">
          <NewInputText
            labelText="Enter Ext Id"
            extraClass={`mb-3 w-100 `}
            name="ext_id"
            onChange={formikCopyItem.handleChange}
            value={formikCopyItem.values.ext_id}
          />
          {formikCopyItem.errors.ext_id && formikCopyItem.touched.ext_id ? (
            <div className="pho_14_regular text-danger">
              {formikCopyItem.errors.ext_id}
            </div>
          ) : null}
        </Modal.Body>
        <Modal.Footer className="justify-content-start border-0">
          <Button
            variant="danger"
            className="btn-lg px-5"
            onClick={() => copyItem()}
            // onClick={onClickYesDeleteItem}
          >
            Copy Item
          </Button>
        </Modal.Footer>
      </Modal>
    </React.Fragment>
  );
};

BasicDetails.propTypes = {
  auth: PropTypes.object.isRequired,
  create_new_item_menu_setup: PropTypes.func.isRequired,
  get_category_menu_setup_without_loader: PropTypes.func.isRequired,
  get_menu_items: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  errors: state.errors && state.errors.errors,
  onboarding:
    state.superAdminOnboarding && state.superAdminOnboarding.restaurantDetails,
  allCategory: state.category,
  menuCategory:
    state.superAdminOnboarding && state.superAdminOnboarding.menuCategory,
  food_type:
    state.superAdminOnboarding &&
    state.superAdminOnboarding.restaurantDetails.selected_food_type,
  crusine:
    state.superAdminOnboarding &&
    state.superAdminOnboarding.restaurantDetails.selected_cusine,
  menuCategoryItems:
    state.superAdminOnboarding && state.superAdminOnboarding.menuCategoryItems,
  activeItemId:
    state.superAdminOnboarding && state.superAdminOnboarding.activeItemId,
  all_menu_items:
    state.superAdminOnboarding && state.superAdminOnboarding.all_menu_items,
  productClassification:
    state.superAdminOnboarding &&
    state.superAdminOnboarding.set_product_classification,
});

export default connect(mapStateToProps, {
  get_category_menu_setup_without_loader,
  create_new_item_menu_setup,
  update_item_menu_setup,
  get_menu_items,
})(BasicDetails);

function UtterancesModel(props) {
  const [open, setOpen] = React.useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <div>
      {/* <Button
        variant="danger"
        onClick={handleClickOpen}
        // onClick={SpeechRecognition.startListening}
      >
        <SVG
           src={require("../../../../../assets/images/UserManagement/microphone.svg")}
          width="22px"
          height="30px"
        />
      </Button> */}
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="form-dialog-title"
      >
        <DialogTitle id="form-dialog-title">Utterances</DialogTitle>
        <DialogContent>
          <div className="f12-700">Mention the utterances for the item</div>
          <ChipsInput setKeywords={props.setKeywords} />
          {/* <TextField
            autoFocus
            margin="dense"
            id="name"
            label="Email Address"
            type="email"
            fullWidth
          /> */}
          <div class="d-flex mt-5">
            <button
              type="button"
              class="btn-md btn btn-outline-secondary"
              title="Back Button"
            >
              Back
            </button>
            <button
              type="button"
              class="btn-md btn btn-danger ml-3 "
              title="Next Button"
            >
              Save and Next
            </button>
          </div>
        </DialogContent>
      </Dialog>
    </div>
  );
}

class ChipsInput extends React.Component {
  state = {
    chips: [],
  };

  addChip = (value) => {
    const chips = this.state.chips.slice();
    chips.push(value);
    this.setState({ chips });
    this.props.setKeywords(chips);
  };
  removeChip = (index) => {
    const chips = this.state.chips.slice();
    chips.splice(index, 1);
    this.setState({ chips });
  };
  render() {
    return (
      <ReactChipInput
        classes="class1 class2"
        chips={this.state.chips}
        onSubmit={(value) => this.addChip(value)}
        onRemove={(index) => this.removeChip(index)}
      />
    );
  }
}
